module.exports = __webpack_public_path__ + "img/02.d98964c0.svg";